var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.54 110.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.18,
    y: 106.23,
    width: 138.11,
    height: 4,
    rx: 2,
    ry: 2,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.25,100.75v4.73c0,.97.78,1.75,1.75,1.75h134.53c.97,0,1.75-.78,1.75-1.75v-4.73H.25Z",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 9.8,
    width: 105.5,
    height: 78.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 9.8,
    width: 105.5,
    height: 78.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.46,
    y: 36.96,
    width: 59.09,
    height: 47.75,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.46,
    y: 12.89,
    width: 59.09,
    height: 10.68,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.76,
    y: 0.25,
    width: 113.02,
    height: 89.85,
    rx: 1.86,
    ry: 1.86,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.51,
    y: 3.59,
    width: 107.52,
    height: 83.17,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.51,
    y: 82.08,
    width: 107.52,
    height: 4.68,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.51,
    y: 3.59,
    width: 107.52,
    height: 6.21,
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.46,
    y: 13.58,
    width: 52.93,
    height: 11.25,
    style: {
      fill: "#77acdd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.46,
    y: 30.44,
    width: 52.93,
    height: 46.89,
    style: {
      fill: "#f47c4a",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.33,
    cy: 22.07,
    r: 8.49,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.51,
    y: 3.59,
    width: 107.52,
    height: 2,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.66,
    cy: 7.69,
    r: 1.31,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.05,
    cy: 7.69,
    r: 1.31,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.44,
    cy: 7.69,
    r: 1.31,
    style: {
      fill: "#f47c4a",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.65,91.09c-.7-.64-1.62-.99-2.57-.99H13.46c-.95,0-1.87.35-2.57.99L.25,100.75h138.04l-10.64-9.66Z",
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.1 91.39 14.44 91.39 8.31 96.91 130.23 96.91 124.1 91.39",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.51 97.86 39.02 97.86 37.76 99.68 100.77 99.68 99.51 97.86",
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.78,
    y1: 93.78,
    x2: 126.76,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.57,
    y1: 96.91,
    x2: 20.22,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.21,
    y1: 96.91,
    x2: 28.42,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.86,
    y1: 96.91,
    x2: 36.63,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.5,
    y1: 96.91,
    x2: 44.83,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.15,
    y1: 96.91,
    x2: 53.03,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.79,
    y1: 96.91,
    x2: 61.24,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.44,
    y1: 96.91,
    x2: 69.44,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.09,
    y1: 96.91,
    x2: 77.64,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.73,
    y1: 96.91,
    x2: 85.85,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.38,
    y1: 96.91,
    x2: 94.05,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.02,
    y1: 96.91,
    x2: 102.25,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.67,
    y1: 96.91,
    x2: 110.46,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.31,
    y1: 96.91,
    x2: 118.66,
    y2: 93.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.21,
    y1: 93.78,
    x2: 26.03,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.48,
    y1: 93.78,
    x2: 33.97,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.75,
    y1: 93.78,
    x2: 41.92,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.02,
    y1: 93.78,
    x2: 49.86,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.3,
    y1: 93.78,
    x2: 57.8,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.57,
    y1: 93.78,
    x2: 65.74,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.84,
    y1: 93.78,
    x2: 73.69,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.11,
    y1: 93.78,
    x2: 81.63,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.38,
    y1: 93.78,
    x2: 89.57,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.66,
    y1: 93.78,
    x2: 97.51,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.93,
    y1: 93.78,
    x2: 105.46,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.2,
    y1: 93.78,
    x2: 113.4,
    y2: 91.39,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".42px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.25,
    y1: 103.86,
    x2: 138.29,
    y2: 103.86,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.e1661d25d564af177a247f28a15029a2.svg";
export { ForwardRef as ReactComponent };